"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LifeCycleState;
(function (LifeCycleState) {
    LifeCycleState["Active"] = "a";
    LifeCycleState["Trash"] = "t";
})(LifeCycleState = exports.LifeCycleState || (exports.LifeCycleState = {}));
var ReferenceType;
(function (ReferenceType) {
    ReferenceType["Banner"] = "b";
    ReferenceType["Collection"] = "c";
    ReferenceType["Template"] = "t";
    ReferenceType["App"] = "a";
    ReferenceType["Item"] = "i";
    ReferenceType["Media"] = "m";
    ReferenceType["Drive"] = "d";
    ReferenceType["Screen"] = "sc";
    ReferenceType["ExportSet"] = "ex";
})(ReferenceType = exports.ReferenceType || (exports.ReferenceType = {}));
//# sourceMappingURL=Common.js.map